import register from '../register.js';
import debounce from './util/debounce.js';
import Orb from './graphics/orb';
import { getBreakpoint } from './util/breakpoint';

register( 'orbs-animation', function() {

  let currBreakpoint = getBreakpoint();
  if ( currBreakpoint === 'small' ) {
    return;
  }

  let opts = {
    numOrbs: 30,
    colors: [
      '#f3766b',
      '#bdcad4',
      '#737e98'
    ],
    sizes: [
      7, 7, 7, 7, 14, 14, 14, 14, 21, 21, 21, 21, 28
    ],
    velocities: [
      0.4,
      0.5,
      0.6,
      0.7
    ]
  };

  let orbs = [];
  let W;
  let H;
  let rAF = window.requestAnimationFrame;
  let canvas = document.getElementById('orbs');
  let ctx = canvas.getContext('2d');
  let ratio = window.devicePixelRatio || 1;
  let ticking = false;

  function calcCanvas() {
    let parent = document.querySelector('.js-orbs-animation');
    let parentHeight = parent.offsetHeight;
    canvas.setAttribute( 'width', window.innerWidth );
    canvas.setAttribute( 'height', parentHeight );
    W = canvas.width;
    H = canvas.height;

    // retina canvas
    if ( ratio !== 1 ) {
      canvas.style.width = canvas.width + 'px';
      canvas.style.height = canvas.height + 'px';
      canvas.width *= ratio;
      canvas.height *= ratio;
      ctx.scale( ratio, ratio );
    }
  }

  function clearCanvas() {
    ctx.clearRect( 0, 0, W, H );
  }

  function createOrbs() {
    let i;
    let v = opts.velocities;
    let colors = opts.colors;
    let sizes = opts.sizes;

    for ( i = 0; i < opts.numOrbs; i++ ) {
      orbs.push(
        new Orb({
          x: 1,
          y: 1,
          bounds: { w: W, h: H },
          direction: {
            x: -1 + Math.random() * 2,
            y: -1 + Math.random() * 2
          },
          velocity: {
            x: v[ Math.floor( Math.random() * v.length ) ],
            y: v[ Math.floor( Math.random() * v.length ) ]
          },
          color: colors[ Math.floor( Math.random() * colors.length ) ],
          radius: sizes[ Math.floor( Math.random() * sizes.length ) ]
        })
      );
    }
  }

  function layoutOrbs() {

    let getNextX = ( function() {
      let x = 1;
      let slot = W / opts.numOrbs;
      return function() {
        return x += slot;
      };
    })();

    let getNextY = ( function() {
      let rows = 6;
      let slot = H / rows;
      let count = 0;
      return function() {
        if ( ++count > rows ) {
          count = 0;
        }
        return count * slot;
      };
    })();

    orbs.forEach( function( orb ) {
      orb.bounds.w = W;
      orb.bounds.h = H;
      orb.x = getNextX();
      orb.y = getNextY();
    });
  }

  function drawOrbs() {
    orbs.forEach( function( orb ) {
      orb.draw( ctx );
    });
  }

  function updateOrbs() {
    orbs.forEach( function( orb ) {
      orb.move();
      orb.boundaryCheck();
    });
  }

  function animateOrbs() {
    if ( ticking ) {
      clearCanvas();
      drawOrbs();
      updateOrbs();
      rAF( animateOrbs );
    }
  }

  function init() {
    calcCanvas();
    createOrbs();
    layoutOrbs();
    ticking = true;
    rAF( animateOrbs );
  }

  // kick off animation
  init();

  // listen for resize
  window.addEventListener( 'resize', debounce( function() {
    calcCanvas();
    layoutOrbs();
  }, 500 ) );

});

export default undefined;
